import React from 'react';
import {FlatList, Pressable, StyleSheet, View} from 'react-native';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import {observer} from 'mobx-react-lite';

import {useStores} from '../stores/use-stores';

import Text from './ui-controls/Text';

const DiscoverFilters = observer(() => {
  const {feedStore, globalStore} = useStores();

  const separator = () => {
    return <View style={styles.separator} />;
  };

  const selectSegment = segment => {
    globalStore.setFiltersVisible(false);
    feedStore.selectSegment(segment);
  };

  const renderSegment = ({item}) => {
    return (
      <Pressable onPress={() => selectSegment(item)}>
        <View style={styles.segmentRow} testID="discover-filter">
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={styles.segmentText}>
            {item.label}
          </Text>
          <FontAwesomeIcon
            icon={faChevronRight}
            size={12}
            style={{color: 'lightgrey'}}
          />
        </View>
      </Pressable>
    );
  };

  return (
    <FlatList
      data={feedStore.segments}
      renderItem={renderSegment}
      ItemSeparatorComponent={separator}
      style={styles.scrollView}
      keyExtractor={item => item.value}
    />
  );
});

export default DiscoverFilters;

const styles = StyleSheet.create({
  // Segment list
  scrollView: {
    width: '100%',
  },
  segmentRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 5,
    left: 1,
  },
  segmentText: {
    fontSize: 16,
    marginLeft: 8,
    textTransform: 'capitalize',
  },
  separator: {
    marginVertical: 4,
    borderBottomWidth: 1,
    borderBottomColor: 'lightgrey',
  },
});
